var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    {
      staticClass: "root",
      attrs: { tag: "w-container", "no-padding": "", "y-snap": "" },
    },
    [
      _c("app-properties", { attrs: { state: _vm.state } }),
      _c("app-rows", { attrs: { state: _vm.state } }),
      _vm.state.sale.Rows.length > 0
        ? _c("app-finish", { attrs: { state: _vm.state } })
        : _vm._e(),
      _vm.state.sendModalOpen
        ? _c("app-send-modal", {
            attrs: { sale: _vm.state.sale },
            on: {
              close: function ($event) {
                _vm.state.sendModalOpen = false
              },
              sent: function ($event) {
                return _vm.saleSent()
              },
            },
          })
        : _vm._e(),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }